module.exports = __webpack_public_path__ + "static/media/19ESCAP30.53fd02f7.jpg";